export default [
  {
    path: "/unallocated",
    name: "unallocated-list",
    meta: {
      title: "Не распределенные операции",
      authRequired: true,
    },
    component: () => import("@/modules/unallocated-operations/views/items.vue"),
  },
  {
    path: "/unallocated/:id",
    name: "unallocated-edit",
    meta: {
      title: "Не распределенная операция",
      authRequired: true,
    },
    component: () => import("@/modules/unallocated-operations/views/edit.vue"),
  },
  {
    path: "/unallocated-test",
    name: "unallocated-test",
    meta: {
      title: "Не распределенная операция",
      authRequired: true,
    },
    component: () => import("@/modules/unallocated-operations/views/test.vue"),
  },
];
